import TextTitleItem, {TextTitleItemProperties} from "../../Data/TextTitleItem";
import * as React from "react";
import showdown from "showdown";

export const StepTitleContent : React.FC<TextTitleItemProperties> = ( props ) => {
    
    if(!props.textTitle) return <></>;
    const titleItem = props.textTitle;
    const converter = new showdown.Converter();

    const regex = new RegExp(`<\/?p>`, 'gi');
    
    const asidePrefix = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className=""><path d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"></path></svg>`

    return (titleItem && (titleItem.title != null || titleItem.paragraph != null || titleItem.aside != null) &&
        <>
            <div className="row gx-4 gy-0 mx-auto align-content-center justify-content-center">
                {titleItem.title != null && <div className="col-12">
                    <h2 className="title-content--title mx-auto text-md-center mt-3">{titleItem.title}</h2>
                </div>}
                {titleItem.paragraph != null && (
                    <div className="col-12">
                        <p className="title-content--paragraph mx-auto text-md-center"
                                            dangerouslySetInnerHTML={{__html: converter.makeHtml(titleItem.paragraph || "")}}>
                            
                        </p>
                    </div>)}
                {titleItem.aside != null && titleItem.aside.length > 0 && (
                    <div className="col-12 col-md-10 col-lg-8 col-xl-7">
                        <aside className="title-content--aside mb-3" role="alert"
                               dangerouslySetInnerHTML={{__html: asidePrefix + converter.makeHtml(titleItem.aside || "")}}>
                        </aside>
                    </div>)}
            </div>
            
        </>
    );
};